import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Box from '@bit/knotchinc.web-react-components.box';
import { Page } from '@bit/knotchinc.web-react-components.page';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import { fetchBrandMetadata, fetchBrandHubs } from 'components/Pages/Entity/actions';
import BrandHubInsightsView from './BrandHubInsightsView.jsx';
import BrandHubOwnedContentView from './BrandHubOwnedContentView.jsx';

export class BrandHubView extends React.Component {
  componentDidMount() {
    this.fetchMeta();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.hubId !== this.props.match.params.hubId) {
      this.fetchMeta();
    }
  }

  fetchMeta() {
    const { getBrandMetadata, getHubs } = this.props;
    getBrandMetadata();
    getHubs();
  }

  render() {
    const { match, metadata, hubsList } = this.props;
    const { data = {}, fetched } = metadata;
    const { params } = match;

    const tabs = [
      { text: 'Content', title: 'Content', link: `${match.url}/content` },
      { text: 'Analytics', title: 'Analytics', link: `${match.url}/analytics` },
    ];

    const previousPageLink = `/blueprint/brand/${params.entityId}/owned`;
    const hubData = hubsList.data.find(entity => entity.public_id === params.hubId) || {};

    return (
      <Page>
        <Box height="320px">
          <PageHeader
            entityLogo={data.logo_url}
            bg={hubData.banner_image_url}
            title={data.name}
            secondaryTitle={hubData.name}
            fetched={fetched}
            tabs={tabs}
            previousPageLink={previousPageLink}
            previousPageLinkTitle="Owned Content"
            isHub
          />
        </Box>
        <Switch>
          <Redirect exact from={match.path} to={`${match.path}/content`} />
          <Route exact path={`${match.path}/content`} component={BrandHubOwnedContentView} />
          <Route exact path={`${match.path}/analytics`} component={BrandHubInsightsView} />
        </Switch>
      </Page>
    );
  }
}

const mapStateToProps = ({ HubsList: { hubsList }, BrandProfile: { metadata } }) => ({ hubsList, metadata });

const mapDispatchToProps = (dispatch, { match: { params } }) => ({
  getBrandMetadata: () => dispatch(fetchBrandMetadata(params.entityId)),
  getHubs: () => dispatch(fetchBrandHubs(true, params.entityId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandHubView);
